import React from "react";
import { useState, useEffect, useRef } from "react";
import { MdOutlineNavigateNext, MdOutlineNavigateBefore } from "react-icons/md";
import { FaShoppingCart } from 'react-icons/fa';
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { FaRuler, FaTimes, FaHeart, FaFire } from "react-icons/fa";
import { addToCart, getCartCount } from "../../utils/cartUtils";
import axios from "axios";
import { X } from "lucide-react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import { addToWishlist, removeFromWishlist, getWishlistProducts } from "../../utils/wishlistUtils";
import { IoEyeSharp } from "react-icons/io5";
import { Helmet } from "react-helmet-async";
import { RxCross1 } from "react-icons/rx";

const ProductDetail4 = ({ data }) => {
  const productsDetails = data["get_products_details"][0];
  const imageData = data["get_similar_product_lists"];
  const [activeTab, setActiveTab] = useState("Product Detail"); // Default tab is "What you get"
  const [isExpanded, setIsExpanded] = useState(false);
  const images = data["get_products_details"][0]["product_images"];
  const colors = data["color_products_lists"];
  const sizes = data["get_products_details"][0]["size"];
  const sizePrice = data["get_products_details"][0]["get_price_lists"];
  const isCustomizable =
    data["get_products_details"][0]["Customizable"] === "Yes";
  const app_type_id = sessionStorage.getItem("app_type_id");
  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const [pincode, setPincode] = useState(
    sessionStorage.getItem("userPincode") || ""
  );
  const [message, setMessage] = useState("");
  const [messageColor, setMessageColor] = useState("");
  const [loading, setLoading] = useState(false);

  const [selectedSize, setSelectedSize] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(
    productsDetails.final_product_price
  );
  const [currentOffer, setCurrentOffer] = useState(
    productsDetails.offer_percentage
  );
  const [originalPrice, setOriginalPrice] = useState(
    productsDetails.product_price
  );

  const [selectedSizeId, setSelectedSizeId] = useState(null);
  const [wishlisted, setWishlisted] = useState(() => {
    return data?.get_products_details?.[0]?.wishlisted === "Yes";
  });




  // useEffect(() => {
  //   setWishlisted(
  //     data?.get_products_details?.[0]?.wishlisted === "Yes"
  //   );
  // }, [productsDetails.product_auto_id]);




  const handleSizeSelect = (size, index) => {
    setSelectedSize(size.size_name);
    setSelectedSizeId(size.size_auto_id);
    const selectedPrice = sizePrice[index];
    if (selectedPrice) {
      setCurrentPrice(selectedPrice.final_size_price);
      setOriginalPrice(selectedPrice.size_price);
      setCurrentOffer(selectedPrice.offer_percentage);
    }
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const [isFixed, setIsFixed] = useState(false);

  const [themeColor, setThemeColor] = useState("#000000")
  const [themeIconColor, setThemeIconColor] = useState("#000000");
  const [webFont, setWebFont] = useState("");
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setWebFont(parsedStyle.web_font);
    }
  }, []);


  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }


  const [cartMessage, setCartMessage] = useState({ text: "", type: "" });

  useEffect(() => {
    if (cartMessage.text) {
      const timer = setTimeout(() => {
        setCartMessage({ text: "", type: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [cartMessage.text]);

  const [isVibrating, setIsVibrating] = useState(false);
  const [wishlistMessage, setWishlistMessage] = useState({ text: "", type: "" });
  useEffect(() => {
    if (wishlistMessage.text) {
      const timer = setTimeout(() => {
        setWishlistMessage({ text: "", type: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [wishlistMessage.text]);





  const handleWishlistToggle = async (e) => {
    e.preventDefault();

    // 🚫 Not logged in
    if (!sessionStorage.getItem("accessToken")) {
      setWishlistMessage({
        text: "Please sign in to add to wishlist",
        type: "error",
      });
      setIsVibrating(true);
      setTimeout(() => setIsVibrating(false), 600);
      return;
    }

    try {
      if (wishlisted) {
        const res = await removeFromWishlist(productsDetails.product_auto_id);
        if (String(res?.status) === "1") {
          setWishlisted(false);
        }
      } else {
        const res = await addToWishlist(productsDetails.product_auto_id);
        if (String(res?.status) === "1") {
          setWishlisted(true);
        }
      }

    } catch (error) {
      console.error("Wishlist error:", error);
    }
  };

  useEffect(() => {
    const syncWishlistStatus = async () => {
      if (!sessionStorage.getItem("accessToken")) {
        setWishlisted(false);
        return;
      }

      try {
        const wishlist = await getWishlistProducts();

        // ✅ normalize array
        const wishlistArray = Array.isArray(wishlist)
          ? wishlist
          : wishlist?.wishlist || wishlist?.getalldata || [];

        const isWishlisted = wishlistArray.some(
          (item) =>
            String(item.product_auto_id) ===
            String(productsDetails.product_auto_id)
        );

        setWishlisted(isWishlisted);
      } catch (err) {
        console.error("Wishlist sync failed", err);
      }
    };

    syncWishlistStatus();
  }, [productsDetails.product_auto_id]);



  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const triggerPosition = 200; // Adjust as per need

      if (scrollY > triggerPosition) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [startIndex, setStartIndex] = useState(0);
  const itemsPerPage = 5; // Adjust based on screen size

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - itemsPerPage, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) =>
      Math.min(prev + itemsPerPage, imageData.length - itemsPerPage)
    );
  };

  const [showReadMore, setShowReadMore] = useState(false);
  const [shortDescription, setShortDescription] = useState("");
  const [remainingDescription, setRemainingDescription] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (productsDetails?.description) {
      const desc = productsDetails.description.trim();
      // Set threshold for when to show "Read More" (e.g., 150 characters)
      if (desc.length > 150) {
        setShortDescription(desc.substring(0, 150) + "...");
        setRemainingDescription(desc.substring(150));
        setShowReadMore(true);
      } else {
        setShortDescription(desc);
        setShowReadMore(false);
      }
    }
  }, [productsDetails?.description]);

  const [chartImage, setChartImage] = useState(null);
  const [chartImage2, setChartImage2] = useState(null);
  const [isSizeGuideModalOpen, setIsSizeGuideModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Size Chart");
  const toggleSizeGuideModal = () =>
    setIsSizeGuideModalOpen(!isSizeGuideModalOpen);

  useEffect(() => {
    const fetchSizeChart = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_size_chart_list`,
          {
            admin_auto_id,
            app_type_id,
          }
        );

        if (response.data.status === "1") {
          const list = response.data.getalldata || [];

          // Find correct objects
          const sizeChartObj = list.find(
            (item) => item.chart_image && item.chart_image !== ""
          );

          const internationalChartObj = list.find(
            (item) =>
              item.international_size_chart &&
              item.international_size_chart !== ""
          );

          if (sizeChartObj) {
            setChartImage(
              `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${sizeChartObj.chart_image}`
            );
          }

          if (internationalChartObj) {
            setChartImage2(
              `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${internationalChartObj.international_size_chart}`
            );
          }
        }
      } catch (error) {
        console.error("Failed to load size chart:", error);
      }
    };

    fetchSizeChart();
  }, [admin_auto_id, app_type_id]);


  useEffect(() => {
    if (isSizeGuideModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Clean up when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isSizeGuideModalOpen]);

  const handleCheckPincode = async (pin) => {
    setLoading(true);
    setMessage("");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_pincode_list`,
        {
          admin_auto_id: admin_auto_id,
          user_auto_id: admin_auto_id,
        }
      );

      if (response.data.status === 1) {
        const pincodeList = response.data.get_pincode_list.map(
          (item) => item.pincode
        );
        if (pincodeList.includes(pin.trim())) {
          setMessage(`Good news! We deliver to ${pin}.`);
          setMessageColor("text-green-600");
        } else {
          setMessage(`Sorry, currently we are unable to deliver at ${pin}.`);
          setMessageColor("text-red-600");
        }
      } else {
        setMessage("Failed to fetch delivery data.");
        setMessageColor("text-red-600");
      }
    } catch (error) {
      console.error("Error checking pincode:", error);
      setMessage("Something went wrong. Please try again.");
      setMessageColor("text-red-600");
    } finally {
      setLoading(false);
    }
  };

  // Updated useEffect for automatic pincode checking
  useEffect(() => {
    if (pincode && pincode.length >= 6 && pincode.length <= 8) {
      handleCheckPincode(pincode);
    } else if (pincode && (pincode.length < 6 || pincode.length > 8)) {
      sessionStorage.removeItem("userPincode");
      setPincode("");
    }
  }, []); // Run only on mount

  // Updated pincode input handler
  const handlePincodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Allow only digits
    setPincode(value);
    if (value.length >= 6 && value.length <= 8) {
      handleCheckPincode(value);
    } else if ((value.length < 6 || value.length > 8) && message) {
      setMessage(""); // Clear message if pincode is invalid
      setMessageColor("");
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedImage(file);
      const reader = new FileReader();
      reader.onload = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setUploadedImage(null);
    setImagePreview(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const [uploadedImage, setUploadedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);



  const [isBoughtFactual, setIsBoughtFactual] = useState(false);
  const [isProductViewsFactual, setIsProductViewsFactual] = useState(false);
  const [isQuantityLeftFactual, setIsQuantityLeftFactual] = useState(false);
  const [quantityLeftFactualValue, setQuantityLeftFactualValue] = useState(1);

  // State to control which messages to show
  const [showMessages, setShowMessages] = useState(false);
  const [showBought, setShowBought] = useState(false);
  const [showViews, setShowViews] = useState(false);
  const [showStock, setShowStock] = useState(false);
  const [randomStocks, setRandomStocks] = useState([]);
  const [isMarketingKeysLoading, setIsMarketingKeysLoading] = useState(true);

  useEffect(() => {
    const fetchMarketingKeys = async () => {
      setIsMarketingKeysLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_marketing_keys`,
          {
            admin_auto_id,
            app_type_id,
          }
        );

        if (response.data.status === "1" && response.data.data.length > 0) {
          const apiData = response.data.data[0];
          setIsBoughtFactual(apiData.is_bought_factual);
          setIsProductViewsFactual(apiData.is_product_views_factual);
          setIsQuantityLeftFactual(apiData.is_quantity_left_factual);
          setQuantityLeftFactualValue(apiData.quantity_left_factual_value);
        } else {
          console.error("Failed to fetch marketing keys:", response.data.msg);
        }
      } catch (error) {
        console.error("Error fetching marketing keys:", error);
      } finally {
        setIsMarketingKeysLoading(false);
      }
    };

    fetchMarketingKeys();
  }, [admin_auto_id, app_type_id]);

  useEffect(() => {
    if (isMarketingKeysLoading) {
      console.log("Waiting for marketing keys to load...");
      return;
    }

    const shouldShowMessages = Math.random() < 0.9;
    setShowMessages(shouldShowMessages);

    if (shouldShowMessages) {
      const randomChoice = Math.random();
      if (randomChoice < 0.33) {
        setShowBought(true);
        setShowViews(false);
      } else if (randomChoice < 0.66) {
        setShowBought(false);
        setShowViews(true);
      } else {
        setShowBought(true);
        setShowViews(true);
      }
    } else {
      setShowBought(false);
      setShowViews(false);
    }

    const shouldShowStock = Math.random() < 0.9;
    setShowStock(shouldShowStock);

    if (shouldShowStock) {
      const stock = parseInt(quantityLeftFactualValue, 10);

      if (isNaN(stock) || stock <= 0) {
        setRandomStocks(sizes.map(() => 0));

      } else {
        const newRandomStocks = sizes.map(() => Math.floor(Math.random() * stock) + 1);
        setRandomStocks(newRandomStocks);

      }
    } else {
      const originalStocks = sizes.map((size) => parseInt(size.size_stock, 10));
      setRandomStocks(originalStocks);

    }
  }, [productsDetails.available_stock, sizes, quantityLeftFactualValue, isMarketingKeysLoading]);

  const getRandomBoughtCount = (count) => {
    const base = parseInt(count) || 0;
    const lower = Math.floor(base * 0.8);  // -20%
    const upper = Math.ceil(base * 1.2);   // +20%
    return Math.floor(Math.random() * (upper - lower + 1)) + lower;
  };

  const getRandomViewCount = (count) => {
    const base = parseInt(count) || 0;
    const lower = Math.floor(base * 0.8);  // -20%
    const upper = Math.ceil(base * 1.2);   // +20%
    return Math.floor(Math.random() * (upper - lower + 1)) + lower;
  };

  const [boughtCount, setBoughtCount] = useState(getRandomBoughtCount(productsDetails.bought_count));
  const [viewCount, setViewCount] = useState(getRandomViewCount(productsDetails.view_count));
  // Update boughtCount when productsDetails.bought_count changes
  useEffect(() => {
    setBoughtCount(getRandomBoughtCount(productsDetails.bought_count));
    setViewCount(getRandomViewCount(productsDetails.view_count));
  }, [productsDetails.bought_count, productsDetails.view_count]);


  const [crossSellingProducts, setCrossSellingProducts] = useState([]);
  const [crossSellingLoading, setCrossSellingLoading] = useState(false);




  // Fetch cross-selling products
  useEffect(() => {
    const fetchCrossSellingProducts = async () => {
      const crossSellingIds = productsDetails.cross_selling_products
        ? productsDetails.cross_selling_products.split("|").filter((id) => id)
        : [];

      if (crossSellingIds.length === 0) {
        setCrossSellingProducts([]);
        return;
      }

      setCrossSellingLoading(true);
      try {
        const products = [];
        for (const product_auto_id of crossSellingIds) {
          const formData = new FormData();
          formData.append("admin_auto_id", admin_auto_id);
          formData.append("app_type_id", app_type_id);
          formData.append("user_auto_id", admin_auto_id);
          formData.append("product_auto_id", product_auto_id);
          formData.append("customer_auto_id", admin_auto_id);
          formData.append("sub_category_auto_id", admin_auto_id);

          const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/get_product_details`, {
            method: "POST",
            body: formData,
          });

          if (!response.ok) {
            console.error(`Failed to fetch product details for ID: ${product_auto_id}`);
            continue;
          }

          const responseData = await response.json();
          if (responseData?.get_products_details?.[0]) {
            products.push(responseData.get_products_details[0]);
          }
        }
        setCrossSellingProducts(products);
      } catch (error) {
        console.error("Error fetching cross-selling products:", error);
        setCrossSellingProducts([]);
      } finally {
        setCrossSellingLoading(false);
      }
    };

    if (productsDetails.cross_selling_products) {
      fetchCrossSellingProducts();
    }
  }, [productsDetails.cross_selling_products, admin_auto_id, app_type_id]);

  useEffect(() => {
    if (Array.isArray(data?.product_faqs)) {
      const formattedFaqs = data.product_faqs
        .filter(item => item?.question && item?.answer)
        .map(item => ({
          question: item.question,
          answer: item.answer,
        }));

      setFaqs(formattedFaqs);
      console.log("FAQs:", faqs);

    }
  }, [data]); // 👈 VERY IMPORTANT



  return (
    <>
      <Helmet>
        {/* 🔹 Dynamic Title */}
        <title>
          {productsDetails?.product_name
            ? `${productsDetails.product_name} `
            : "Product Details"}
        </title>

        {/* 🔹 Meta Description */}
        <meta
          name="description"
          content={
            productsDetails?.description
              ? productsDetails.description
                .replace(/(<([^>]+)>)/gi, "")
              : "Buy products online at best price."
          }
        />

        {/* 🔹 Keywords */}
        <meta
          name="keywords"
          content={
            productsDetails?.keywords
              ? productsDetails.keywords
              : "online shopping, ecommerce product"
          }
        />



        {/* 🔹 PRODUCT SCHEMA (JSON-LD) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            name: productsDetails?.product_name,
            description: productsDetails?.description
              ?.replace(/(<([^>]+)>)/gi, "")
              .slice(0, 160),
            image: productsDetails?.product_images?.map(
              (img) =>
                `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`
            ),
            offers: {
              "@type": "Offer",
              priceCurrency: "INR",
              price: productsDetails?.final_product_price,
              availability:
                productsDetails?.available_stock > 0
                  ? "https://schema.org/InStock"
                  : "https://schema.org/OutOfStock",
            },
          })}

        </script>





      </Helmet>
      <style>
        {`
  * {
    box-sizing: border-box;
  }

  body, html {
    overflow-x: hidden !important;
  }

  @keyframes wiggle {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-3px); }
    50% { transform: translateX(3px); }
    75% { transform: translateX(-3px); }
  }

  .wiggle {
    animation: wiggle 0.2s ease-in-out 3;
  }

  .disabled-overlay::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 8%;
    right: 8%;
    height: 1px;
    background-color: #9ca3af;
    transform: translateY(-50%);
    pointer-events: none;
  }
`}
      </style>
      <div className="relative block w-full lg:w-1/2 lg:hidden">
        <img
          src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${images[currentIndex].product_image}`}
          alt="Product"
          className="
       shadow-lg w-full
      h-80 sm:h-88 md:h-96 
      lg:h-[600px]
      object-cover cursor-pointer
    "
          onClick={() => setIsModalOpen(true)}
        />

        {/* <button
    onClick={prevSlide}
    className="absolute p-2 transform -translate-y-1/2 bg-white rounded-full shadow-lg left-2 top-1/2"
  >
    <MdOutlineNavigateBefore className="text-xl text-black" />
  </button>

  <button
    onClick={nextSlide}
    className="absolute p-2 transform -translate-y-1/2 bg-white rounded-full shadow-lg right-2 top-1/2"
  >
    <MdOutlineNavigateNext className="text-xl text-black" />
  </button> */}

        <div className="absolute flex space-x-1 transform -translate-x-1/2 bottom-3 left-1/2">
          {images.map((_, index) => (
            <span
              key={index}
              className={`h-2 w-2 rounded-full ${currentIndex === index ? "bg-white" : "bg-white/50"
                }`}
            />
          ))}
        </div>
      </div>
      <div className={`p-3 mx-auto space-y-6 max-w-7xl ${webFont}`}>
        {/* Product Details Section */}
        <div className="flex flex-col gap-4 p-0 lg:flex-row">
          {/* Image Section */}
          <div className="relative hidden w-full lg:w-1/2 lg:block">
            <img
              src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${images[currentIndex].product_image}`}
              alt="Product"
              className="
    rounded-xl shadow-lg w-full
    sm:h-80 
    md:h-96 
    lg:h-[500px]
    object-cover cursor-pointer
  "
              onClick={() => setIsModalOpen(true)}
            />


            <button
              onClick={prevSlide}
              className="absolute p-2 transform -translate-y-1/2 bg-white rounded-full shadow-lg left-2 top-1/2"
            >
              <MdOutlineNavigateBefore className="text-xl text-black" />
            </button>

            <button
              onClick={nextSlide}
              className="absolute p-2 transform -translate-y-1/2 bg-white rounded-full shadow-lg right-2 top-1/2"
            >
              <MdOutlineNavigateNext className="text-xl text-black" />
            </button>

            <div className="absolute flex space-x-1 transform -translate-x-1/2 bottom-3 left-1/2">
              {images.map((_, index) => (
                <span
                  key={index}
                  className={`h-2 w-2 rounded-full ${currentIndex === index ? "bg-white" : "bg-white/50"
                    }`}
                />
              ))}
            </div>
          </div>


          {/* Fullscreen Modal */}
          {isModalOpen && (
            <div className="fixed inset-0 z-50 flex bg-black bg-opacity-90">
              {/* Thumbnail Sidebar */}
              <div className="w-24 p-2 overflow-y-auto">
                {images.map((img, index) => (
                  <img
                    key={img.image_auto_id}
                    src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`}
                    alt=""
                    onClick={() => setCurrentIndex(index)}
                    className={`w-full h-20 object-cover mb-2 rounded-md cursor-pointer border-2 ${currentIndex === index ? "border-white" : "border-transparent"
                      }`}
                  />
                ))}
              </div>

              {/* Full Image Display */}
              <div
                className="relative flex items-center justify-center flex-1"
                onMouseMove={(e) => {
                  const rect = e.currentTarget.getBoundingClientRect();
                  const x = ((e.clientX - rect.left) / rect.width) * 100;
                  const y = ((e.clientY - rect.top) / rect.height) * 100;
                  e.currentTarget.children[0].style.transformOrigin = `${x}% ${y}%`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.children[0].style.transformOrigin = 'center';
                }}
              >
                <img
                  src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${images[currentIndex].product_image}`}
                  alt=""
                  className="object-contain max-h-[90vh] max-w-[90vw] transition-transform duration-300 ease-in-out hover:scale-[2.5]"
                />

                <button
                  onClick={() => setIsModalOpen(false)}
                  className="absolute text-3xl text-white top-5 right-5"
                >
                  &times;
                </button>
              </div>

            </div>
          )}

          {/* Details Section */}
          <div className="relative space-y-4 lg:w-1/2 pb-36">
            <div className="flex items-start justify-between gap-2">

              {/* Product Title */}
              <h1 className="flex-1 min-w-0 text-lg font-bold break-words sm:text-xl md:text-2xl">
                {productsDetails.product_name}
              </h1>

              {/* Wishlist Button */}
              <div className="relative flex-shrink-0">
                <button
                  onClick={handleWishlistToggle}
                  className={`p-1 rounded-full 
    ${wishlisted ? "text-red-500" : "text-gray-500"} 
    ${isVibrating ? "wiggle" : ""}`}
                >
                  {wishlisted ? (
                    <FaHeart className="w-5 h-5 sm:w-6 sm:h-6" />
                  ) : (
                    <FiHeart className="w-5 h-5 sm:w-6 sm:h-6" />
                  )}
                </button>


                {/* Wishlist Action Message */}
                {wishlistMessage.text && (
                  <div
                    className={`absolute 
          left-1/2 -translate-x-1/2  /* Center on mobile */
          sm:left-[-7rem] sm:translate-x-0 
          -bottom-6 
          text-xs px-2 py-1 rounded bg-white z-10 whitespace-nowrap
          ${wishlistMessage.type === "error" ? "text-red-500" : "text-green-500"}
        `}
                  >
                    {wishlistMessage.text}
                  </div>
                )}
              </div>

            </div>

            {productsDetails?.highlights?.trim() && (
              <p className="text-gray-700">{productsDetails.highlights}</p>
            )}

            {/* {productsDetails?.unit?.trim() && (
              <p className="flex items-center text-gray-600">
                <FaShoppingCart className="mr-1 text-lg" />
                {productsDetails.unit}
              </p>
            )} */}

            <div className="space-y-2">
              <p className="mb-0 text-gray-700">
                {showReadMore && !isExpanded
                  ? shortDescription
                  : productsDetails?.description}
              </p>

              {showReadMore && (
                <button
                  className="text-black underline cursor-pointer "
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded ? "Read Less" : "Read More"}
                </button>
              )}
            </div>

            <div className="mt-1">
              {showBought && isBoughtFactual && (
                <p className="flex items-center text-sm font-medium font-extrabold text-black">
                  {boughtCount}+ bought this !
                </p>
              )}
            </div>

            {/* Price */}
            <p className="text-lg font-semibold text-gray-500">
              MRP: <span style={{ color: themeColor }}>₹{currentPrice}</span>
              {parseInt(currentOffer) > 0 && (
                <>
                  <span className="ml-2 text-gray-400 line-through">
                    ₹{originalPrice}
                  </span>
                  <span className="px-2 py-1 ml-2 text-sm text-white rounded-full"
                    style={{ backgroundColor: themeColor }}>
                    {currentOffer}% OFF
                  </span>
                </>
              )}
            </p>
            <p className="text-lg font-semibold text-gray-500">
              {productsDetails.including_tax === "Yes" ? "(incl. of all taxes)" : "(excl. of all taxes)"}
            </p>

            {/* Add Button in Bottom Right Corner */}
            <button
                  className={`
    w-50 md:px-12 py-3 text-white rounded-lg absolute
    bottom-12 left-1/2 -translate-x-1/2   
    lg:bottom-14 lg:left-auto lg:right-0 lg:translate-x-0  
    ${sizes?.length > 0 && !selectedSize
                  ? "bg-gray-400 opacity-50 cursor-not-allowed"
                  : ""
                }
  `}
                  style={{ backgroundColor: sizes?.length > 0 && !selectedSize ? "" : themeColor }}
                  onMouseEnter={(e) => {
                    const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
                    e.currentTarget.style.backgroundColor = sizes?.length > 0 && !selectedSize ? "" : darkenedColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = sizes?.length > 0 && !selectedSize ? "" : themeColor;
                  }}
                  disabled={sizes?.length > 0 && !selectedSize}
                  onClick={async () => {
                    if (sizes?.length === 0 || selectedSize) {
                      try {
                        const payload = {
                          product_auto_id: productsDetails?.product_auto_id,
                          added_by_id: productsDetails?.user_auto_id,
                          cart_quantity:
                            productsDetails?.moq && productsDetails.moq !== ""
                              ? productsDetails.moq
                              : 1,
                          ...(sizes?.length !== 0 && {
                            size: selectedSizeId,
                            size_price: currentPrice,
                          }),
                          ...(isCustomizable &&
                            uploadedImage && { cust_image: uploadedImage }),
                        };

                        const res = await addToCart(payload);

                        // 🚫 ALREADY IN CART → stop here
                        if (res?.message && res.message.toLowerCase().includes("already")) {
                          setCartMessage({
                            text: "Product is already present in cart",
                            type: "error",
                          });
                          return; // ⛔ no navigation
                        }

                        // ✅ SUCCESS
                        if (res?.status === "1") {
                          setCartMessage({
                            text: res.message || "Added to cart",
                            type: "success",
                          });

                          setTimeout(() => {
                            navigate("/cart");
                          }, 1000);
                        } else {
                          setCartMessage({
                            text: res?.message || "Failed to add product to cart",
                            type: "error",
                          });
                        }

                      } catch (error) {
                        setCartMessage({ text: error.message || "Failed to add product to cart.", type: "error" });
                      }
                    } else {
                      setCartMessage({ text: "Select a Size", type: "error" });
                      return;
                    }
                  }}
                >
                  {sizes?.length > 0 && !selectedSize
                    ? "Select"
                    : `Add | ₹ ${sizes?.length > 0
                      ? currentPrice
                      : productsDetails?.final_product_price
                    }`}
                </button>


            <div className="w-full mt-4 border-t"></div>

            {colors && colors.length > 0 && (
              <div className="flex flex-col mt-3 space-y-1">
                <label className="text-sm font-medium text-gray-700">
                  Color:
                </label>
                <div className="flex mt-1 space-x-2">
                  {colors.map((color) => (
                    <Link
                      to={`/product-detail/${color.product_auto_id}`}
                      key={color.product_auto_id}
                      className="w-8 h-8 border border-gray-300 rounded-full shadow-sm cursor-pointer"
                      style={{
                        backgroundColor: color.color_code
                          ? color.color_code
                            .replace("Color(0xff", "#")
                            .replace(")", "")
                          : "#000000", // Fallback color if color_code is null/undefined
                      }}
                      title={color.color_name}
                    />
                  ))}
                </div>
              </div>
            )}

            {/* {colors && colors.length > 0 && (
                <div className="flex flex-col mt-4 space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                  Color:
                </label>
                  <div className="flex mt-2 space-x-3">
                    {colors.map((color) => {
                      const imageUrl = color.color_image
                        ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${color.color_image}`
                        : 'https://via.placeholder.com/400x400?text=No+Image';
                      return (
                        <Link
                          to={`/product-detail/${color.product_auto_id}`}
                          key={color.product_auto_id}
                          className="relative w-16 overflow-hidden transition-all duration-200 border-2 shadow-md cursor-pointer h-28"
                          title={color.color_name}
                          onClick={() => console.log(`Attempting to load image: ${imageUrl}`)}
                          style={{ borderColor: lightenHexColor(themeColor,0.2) }}
                        onMouseEnter={(e) => {
                          const darkenedColor = darkenHexColor(themeColor, 0.15); 
                          e.currentTarget.style.borderColor = darkenedColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = lightenHexColor(themeColor,0.2) ;
                        }}
                          
                        >
                          <img
                            src={imageUrl}
                            alt={color.color_name || 'Color Image'}
                            className="object-cover w-full h-full"
                            onError={(e) => {
                              console.error(`Failed to load image: ${imageUrl}`);
                              e.target.src = 'https://via.placeholder.com/400x400?text=Image+Failed';
                            }}
                          />
                          
                        </Link>
                      );
                    })}
                  </div>
                </div>
              )} */}

            {sizes?.length > 0 && (
              <h3 className="flex items-center justify-between mt-4 space-x-4 text-gray-400 text-bold">
                <span className="text-sm ">Select</span>
                <div className="flex items-center ml-auto text-gray-500 cursor-pointer hover:text-gray-700">
                  {(chartImage || chartImage2) && (
                    <>
                      <button
                        className="mr-2 text-sm font-medium underline"
                        onClick={toggleSizeGuideModal}
                      >
                        Size Chart
                      </button>
                      <FaRuler className="w-5 h-5" />
                    </>
                  )}
                </div>
              </h3>
            )}

            {/* Sidebar Modal */}
            {isSizeGuideModalOpen && (
              <div className="fixed inset-0 z-50 flex justify-end">
                {/* Click Outside to Close */}
                <div
                  className="flex-1 bg-black bg-opacity-50"
                  onClick={toggleSizeGuideModal}
                ></div>

                <div className="w-[360px] h-full bg-white shadow-lg p-6 overflow-y-auto relative transition-transform duration-300">
                  {/* Close Button */}
                  <button
                    onClick={toggleSizeGuideModal}
                    className="absolute text-gray-600 top-4 right-4 hover:text-black"
                  >
                    <X size={24} />
                  </button>

                  {/* Title */}
                  <h2 className="mb-2 text-2xl font-bold text-center">
                    Size Guide
                  </h2>

                  {/* Tabs */}
                  <div className="flex mb-4 border-b">
                    {["Size Chart", "International"].map((tab) => (
                      <button
                        key={tab}
                        onClick={() => setSelectedTab(tab)}
                        className={`flex-1 text-center py-2 font-semibold transition-all ${selectedTab === tab
                          ? "border-b-2 "
                          : "text-gray-600"
                          }`}
                        style={{ color: selectedTab === tab ? themeColor : "", borderColor: selectedTab === tab ? themeColor : "" }}
                      >
                        {tab}
                      </button>
                    ))}
                  </div>

                  {/* Chart Content */}
                  {selectedTab === "Size Chart" && (
                    <div className="space-y-2">
                      {chartImage ? (
                        <img
                          src={chartImage}
                          alt="Size Chart"
                          className="w-full transition-transform duration-300 border rounded-md shadow-sm"
                        />
                      ) : (
                        <p className="text-sm text-center text-gray-500">
                          Chart not available.
                        </p>
                      )}
                    </div>
                  )}

                  {/* International Chart Content */}
                  {selectedTab === "International" && (
                    <div className="space-y-2">
                      {chartImage2 ? (
                        <img
                          src={chartImage2}
                          alt="International Size Chart"
                          className="w-full transition-transform duration-300 border rounded-md shadow-sm"
                        />
                      ) : (
                        <p className="text-sm text-center text-gray-500">
                          Internationalimage not available.
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="flex mt-4 space-x-2">
              {sizes.map((size, index) => {
                const actualStock = parseInt(size.size_stock, 10);
                const isDisabled = !actualStock || isNaN(actualStock) || actualStock <= 0;
                const isSelected = selectedSize === size.size_name;

                const displayStock = showStock ? randomStocks[index] : actualStock;
                const showStockLabel =
                  actualStock > 0 && showStock && isQuantityLeftFactual && displayStock <= 5;

                return (
                  <div key={size.product_auto_id} className="relative">
                    <button
                      className={`relative border w-20 h-12 rounded-full text-sm flex items-center justify-center flex-col transition-colors duration-200 overflow-hidden
            ${isDisabled ? "bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed" : ""}
            ${!isDisabled && isSelected ? "text-white" : ""}
          `}
                      style={{
                        backgroundColor: !isDisabled && isSelected ? themeColor : undefined,
                        borderColor: !isDisabled && isSelected ? themeColor : undefined,
                        color: !isDisabled && isSelected ? "#ffffff" : undefined,
                      }}
                      onClick={() => !isDisabled && handleSizeSelect(size, index)}
                      onMouseEnter={(e) => {
                        if (!isSelected && !isDisabled) {
                          e.currentTarget.style.backgroundColor = themeColor;
                          e.currentTarget.style.color = "#ffffff";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected && !isDisabled) {
                          e.currentTarget.style.backgroundColor = "#ffffff";
                          e.currentTarget.style.color = "#000000";
                        }
                      }}
                      disabled={isDisabled}
                    >
                      {/* Size Label */}
                      <span
                        className={`text-base leading-none ${showStockLabel ? "mb-3" : ""}`}
                      >
                        {size.size_name}
                      </span>

                      {/* Diagonal Slash Line (ONLY when disabled) */}
                      {isDisabled && (
                        <span
                          className="absolute w-[130%] h-[1px] bg-gray-400 left-1/2 top-1/2"
                          style={{
                            transform: "translate(-50%, -50%) rotate(35deg)",
                          }}
                        ></span>
                      )}

                      {/* Stock Label */}
                      {showStockLabel && (
                        <span
                          className="absolute bottom-0 left-0 right-0 px-2 py-[4px] text-[11px] text-center text-white leading-tight"
                          style={{ backgroundColor: themeColor }}
                        >
                          {displayStock} left
                        </span>
                      )}
                    </button>
                  </div>
                );
              })}
            </div>



            <div className="mt-4">
              <p className="flex items-center font-semibold text-gray-500">
                <FaMapMarkerAlt className="mr-2" size={18} /> Check Availability
              </p>
              <div className="flex items-center mt-2">
                <input
                  type="text"
                  placeholder="Enter pincode"
                  value={pincode}
                  onChange={handlePincodeChange}
                  className="w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                  maxLength={8} // Allow up to 8 digits
                  disabled={loading}
                />
              </div>
              {loading && (
                <p className="mt-2 text-sm font-medium text-gray-600">
                  Checking...
                </p>
              )}
              {message && (
                <p className={`mt-2 text-sm font-medium ${messageColor}  p-2 `}>
                  {message}
                </p>
              )}
            </div>

            {isCustomizable && (
              <div className="mt-4 mb-2">
                <p className="flex items-center font-semibold text-gray-500">
                  <span className="mr-2">📷</span> Customize Your Product
                </p>
                <div className="p-4 mt-2 border border-gray-300 rounded-lg bg-gray-50">
                  <p className="mb-2 text-sm text-gray-600">
                    Upload an image to personalize your{" "}
                    {productsDetails.product_name}
                  </p>
                  <div className="flex items-center gap-4">
                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      onChange={handleImageUpload}
                      className="hidden"
                      id="image-upload"
                    />
                    <label
                      htmlFor="image-upload"
                      className="px-4 py-2 text-white transition duration-200 rounded-lg cursor-pointer "
                      style={{ backgroundColor: themeColor }}
                      onMouseEnter={(e) => {
                        const darkenedColor = lightenHexColor(themeColor, 0.1);
                        e.currentTarget.style.backgroundColor = darkenedColor;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = themeColor;
                      }}
                    >
                      Choose Image
                    </label>
                    {imagePreview && (
                      <div className="flex items-center gap-2">
                        <img
                          src={imagePreview}
                          alt="Preview"
                          className="object-cover w-16 h-16 border border-gray-300 rounded-md"
                        />
                        <button
                          onClick={handleRemoveImage}
                          className="p-1 text-red-500 transition bg-gray-100 rounded-full hover:text-red-700 hover:bg-gray-200"
                          aria-label="Remove uploaded image"
                        >
                          <FaTimes size={16} />
                        </button>
                      </div>
                    )}
                  </div>
                  {uploadedImage && (
                    <p className="mt-2 text-sm text-green-600">
                      Image uploaded: {uploadedImage.name}
                    </p>
                  )}
                  <p className="mt-2 text-xs text-gray-500">
                    Supported formats: JPG, PNG, GIF.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Additional Info Section */}
        <div className="hidden p-4 bg-white border rounded-lg shadow-lg lg:block">
          <div className="flex justify-center w-auto p-1 mb-1 space-x-6 border-b">
            {["Product Detail", "Specifications", "Return and Exchange"].map(
              (tab) => (
                <button
                  key={tab}
                  className={`text-2xl font-semibold pb-1 ${activeTab === tab
                    ? "text-black border-b-4 "
                    : "text-gray-600"
                    }`}
                  style={{ borderColor: activeTab === tab ? themeColor : "" }}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              )
            )}
          </div>

          {/* Content Section */}
          <div className="grid grid-cols-[1fr_3fr] gap-6">
            {/* Left Image */}
            <div>
              <img
                src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${images[currentIndex].product_image}`}
                alt="Tab Content"
                className="object-cover w-auto rounded-lg h-80"
              />
            </div>

            {/* Right Content */}
            <div className="max-h-[300px] overflow-y-auto pr-4">
              {activeTab === "Product Detail" && (
                <div>
                  <h3 className="mb-2 text-lg font-semibold">Description</h3>
                  <p>
                    {productsDetails.description || "No description available"}
                  </p>
                </div>
              )}

              {activeTab === "Specifications" && (
                <div>
                  <h3 className="mb-2 text-lg font-semibold">Specifications</h3>
                  <ul className="pl-6 list-disc">
                    {productsDetails.specification_details &&
                      productsDetails.specification_details.length > 0 ? (
                      productsDetails.specification_details.map(
                        (spec, index) => (
                          <li key={index}>
                            {spec.title && <strong>{spec.title}: </strong>}
                            {spec.description || "No specification details"}
                          </li>
                        )
                      )
                    ) : (
                      <li>No specifications available</li>
                    )}
                  </ul>
                </div>
              )}

              {activeTab === "Return and Exchange" && (
                <div>
                  <h3 className="mb-2 text-lg font-semibold">
                    Return & Exchange Policy
                  </h3>
                  <ul className="pl-6 list-disc">
                    <li>
                      {productsDetails.isReturn === "Yes"
                        ? "Return available within " +
                        (productsDetails.days || "7") +
                        " " +
                        (productsDetails.time_unit || "days")
                        : "Return not available"}
                    </li>
                    <li>
                      {productsDetails.isExchange === "Yes"
                        ? "Exchange available within " +
                        (productsDetails.days || "7") +
                        " " +
                        (productsDetails.time_unit || "days")
                        : "Exchange not available"}
                    </li>
                    {productsDetails.Trial_Period && (
                      <li>Trial Period: {productsDetails.Trial_Period}</li>
                    )}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Mobile Only Section */}
        <div className="p-2 bg-white border rounded-lg shadow-lg md:hidden">
          {/* Product Image */}
          <div className="mb-4">
            <img
              src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${images[currentIndex].product_image}`}
              alt="Product"
              className="object-cover w-full h-64 rounded-lg"
            />
          </div>

          {/* Tabs */}
          <div className="flex justify-around mb-4 border-b ">
            {["Product Detail", "Specifications", "Return & Exchange"].map((tab) => (
              <button
                key={tab}
                className={`flex-1 py-2 text-center font-semibold border border-gray-200 ${activeTab === tab ? "text-black border-b-2" : "text-gray-500"
                  }`}
                style={{ borderColor: activeTab === tab ? themeColor : "" }}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>


          {/* Tab Content */}
          <div className="max-h-[300px] overflow-y-auto">
            {activeTab === "Product Detail" && (
              <div>
                <h3 className="mb-2 text-lg font-semibold">Description</h3>
                <p>{productsDetails.description || "No description available"}</p>
              </div>
            )}

            {activeTab === "Specifications" && (
              <div>
                <h3 className="mb-2 text-lg font-semibold">Specifications</h3>
                <ul className="pl-4 list-disc">
                  {productsDetails.specification_details &&
                    productsDetails.specification_details.length > 0 ? (
                    productsDetails.specification_details.map((spec, index) => (
                      <li key={index}>
                        {spec.title && <strong>{spec.title}: </strong>}
                        {spec.description || "No specification details"}
                      </li>
                    ))
                  ) : (
                    <li>No specifications available</li>
                  )}
                </ul>
              </div>
            )}

            {activeTab === "Return & Exchange" && (
              <div>
                <h3 className="mb-2 text-lg font-semibold">Return & Exchange Policy</h3>
                <ul className="pl-4 list-disc">
                  <li>
                    {productsDetails.isReturn === "Yes"
                      ? `Return available within ${productsDetails.days || "7"} ${productsDetails.time_unit || "days"}`
                      : "Return not available"}
                  </li>
                  <li>
                    {productsDetails.isExchange === "Yes"
                      ? `Exchange available within ${productsDetails.days || "7"} ${productsDetails.time_unit || "days"}`
                      : "Exchange not available"}
                  </li>
                  {productsDetails.Trial_Period && <li>Trial Period: {productsDetails.Trial_Period}</li>}
                </ul>
              </div>
            )}
          </div>
        </div>
        {/* Similar Products Section */}
        <div className="relative px-0 pt-6 pb-24 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <h2 className="mb-6 text-xl font-semibold">SIMILAR PRODUCTS</h2>

          <div className="relative">
            {/* Navigation Buttons (Desktop Only) */}
            <button
              onClick={handlePrev}
              disabled={startIndex === 0}
              className={`hidden md:flex absolute -left-12 top-1/2 transform -translate-y-1/2 p-2 bg-white border rounded-full shadow-md hover:bg-gray-200 transition-colors z-10 ${startIndex === 0 ? "opacity-50 cursor-not-allowed" : ""
                }`}
            >
              <ChevronLeft size={24} />
            </button>

            {/* PRODUCT LIST - Mobile Slider + Desktop Grid */}
            <div
              className="flex gap-4 overflow-x-auto scrollbar-hide sm:grid sm:grid-cols-3 sm:gap-6 sm:overflow-visible md:grid-cols-4 lg:grid-cols-5"
            >
              {imageData
                .slice(startIndex, startIndex + itemsPerPage)
                .map((product) => (
                  <Link
                    key={product.product_auto_id}
                    to={`/product-detail/${product.product_auto_id}`}
                    className="
              min-w-[280px] sm:min-w-0
              no-underline transition-shadow rounded-md hover:shadow-md
            "
                  >
                    <div className="relative flex flex-col h-full bg-white border border-gray-100 rounded-md">

                      {/* Image */}
                      <div className="flex items-center justify-center mb-3 overflow-hidden bg-gray-100 rounded-md aspect-square">
                        <img
                          src={
                            product.product_images?.[0]?.product_image &&
                              product.product_images[0].product_image.trim() !== ""
                              ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${product.product_images[0].product_image}`
                              : "https://placehold.co/300x400"
                          }
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "https://placehold.co/300x400";
                          }}
                          alt={product.product_name}
                          className="object-contain w-full h-full"
                        />
                      </div>



                      {/* Product Info */}
                      <div className="flex-grow">
                        <h3 className="mb-1 text-sm font-medium text-gray-900 truncate">
                          {product.product_name}
                        </h3>

                        <p className="mb-2 text-xs text-gray-500 line-clamp-2">
                          {product.description}
                        </p>

                        {/* Price & Discount */}
                        <div className="flex items-center justify-between mt-auto">
                          <span
                            className="font-semibold"
                            style={{ color: themeColor }}
                          >
                            ₹{product.product_price}
                          </span>

                          {product.offer_percentage && (
                            <span
                              className="px-2 py-1 text-xs rounded"
                              style={{
                                color: darkenHexColor(themeColor, 0.2),
                                backgroundColor: lightenHexColor(themeColor, 0.2),
                              }}
                            >
                              {product.offer_percentage}% off
                            </span>
                          )}
                        </div>

                        {/* Delivery Info */}
                        {product.time_unit && (
                          <div className="flex items-center mt-2 text-xs text-gray-500">
                            <span>
                              {product.time} {product.time_unit}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </Link>
                ))}
            </div>

            {/* Desktop Right Button */}
            <button
              onClick={handleNext}
              disabled={startIndex >= imageData.length - itemsPerPage}
              className={`hidden md:flex absolute -right-12 top-1/2 transform -translate-y-1/2 p-2 bg-white border rounded-full shadow-md hover:bg-gray-200 transition-colors z-10 ${startIndex >= imageData.length - itemsPerPage
                ? "opacity-50 cursor-not-allowed"
                : ""
                }`}
            >
              <ChevronRight size={24} />
            </button>
          </div>
        </div>


        {crossSellingProducts.length > 0 && (
          <div className="relative px-0 pt-6 pb-24 mx-auto max-w-7xl sm:px-6 lg:px-8">
            <h2 className="mb-6 text-xl font-semibold">YOU MAY ALSO LIKE</h2>

            <div className="relative">

              {/* Navigation Buttons (Desktop Only) */}
              <button
                onClick={handlePrev}
                disabled={startIndex === 0}
                className={`hidden md:flex absolute -left-12 top-1/2 transform -translate-y-1/2 p-2 bg-white border rounded-full shadow-md hover:bg-gray-200 transition-colors z-10 ${startIndex === 0 ? "opacity-50 cursor-not-allowed" : ""
                  }`}
              >
                <ChevronLeft size={24} />
              </button>

              {/* PRODUCT LIST - Mobile Slider + Desktop Grid */}
              <div
                className="flex gap-4 overflow-x-auto scrollbar-hide sm:grid sm:grid-cols-3 sm:gap-6 sm:overflow-visible md:grid-cols-4 lg:grid-cols-5"
              >
                {crossSellingProducts.map((product) => (
                  <Link
                    key={product.product_auto_id}
                    to={`/product-detail/${product.product_auto_id}`}
                    className="
              min-w-[80%]     /* Mobile: show 1.5 cards */
              sm:min-w-0      /* Desktop: normal grid */
              no-underline transition-shadow rounded-md hover:shadow-md
            "
                  >
                    <div className="relative flex flex-col h-full p-3 bg-white border border-gray-100 rounded-md">

                      {/* Image */}
                      <div className="mb-3 overflow-hidden rounded-md aspect-square">
                        {product.product_images.map((image) => (
                          <img
                            key={image.product_image}
                            src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${image.product_image}`}
                            alt={product.product_name}
                            className="object-cover w-full h-full"
                          />
                        ))}
                      </div>

                      {/* Product Info */}
                      <div className="flex-grow">
                        <h3 className="mb-1 text-sm font-medium text-gray-900 truncate">
                          {product.product_name}
                        </h3>

                        <p className="mb-2 text-xs text-gray-500 line-clamp-2">
                          {product.description}
                        </p>

                        {/* Price & Discount */}
                        <div className="flex items-center justify-between mt-auto">
                          <span className="font-semibold" style={{ color: themeColor }}>
                            ₹{product.product_price}
                          </span>

                          {product.offer_percentage && (
                            <span
                              className="px-2 py-1 text-xs rounded"
                              style={{
                                color: darkenHexColor(themeColor, 0.2),
                                backgroundColor: lightenHexColor(themeColor, 0.2),
                              }}
                            >
                              {product.offer_percentage}% off
                            </span>
                          )}
                        </div>

                        {/* Delivery info */}
                        {product.time_unit && (
                          <div className="flex items-center mt-2 text-xs text-gray-500">
                            <span>
                              {product.time} {product.time_unit}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>

              {/* Desktop Only Right Button */}
              <button
                onClick={handleNext}
                disabled={startIndex >= crossSellingProducts.length - itemsPerPage}
                className={`hidden md:flex absolute -right-12 top-1/2 transform -translate-y-1/2 p-2 bg-white border rounded-full shadow-md hover:bg-gray-200 transition-colors z-10 ${startIndex >= crossSellingProducts.length - itemsPerPage
                  ? "opacity-50 cursor-not-allowed"
                  : ""
                  }`}
              >
                <ChevronRight size={24} />
              </button>
            </div>
          </div>
        )}



        {/* Fixed Scrollback Section */}
        <div className="hidden p-4 mx-auto space-y-6 lg:block max-w-7xl">
          <div
            className={`flex items-center justify-between bg-white border border-b-0 rounded-xl drop-shadow-none p-4 transition-all duration-300 
                    ${isFixed
                ? "fixed bottom-4  left-1/2 transform -translate-x-1/2 w-full max-w-7xl shadow-lg z-50"
                : ""
              }`}
          >
            {/* Image Section */}
            <div className="flex items-center gap-4 ">
              <img
                src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${images[currentIndex].product_image}`}
                alt={productsDetails.product_name}
                className="object-cover h-32 rounded-lg w-28"
              />

              {/* Product Details */}
              <div>
                <h3 className="text-lg font-semibold">
                  {productsDetails.product_name}
                </h3>
                <p className="text-sm text-gray-600">{productsDetails.unit}</p>

                {sizes?.length > 0 && selectedSize && (
                  <p className="text-sm text-gray-600">size - {selectedSize}</p>
                )}
                <p className="text-lg font-bold " style={{ color: themeColor }}>
                  MRP: ₹{currentPrice}
                  {parseInt(currentOffer) > 0 && (
                    <>
                      {" "}
                      <span className="ml-2 text-gray-400 line-through">
                        ₹{originalPrice}
                      </span>
                      <span className="px-2 py-1 ml-2 text-sm text-white rounded-full" style={{ backgroundColor: themeColor }}>
                        {currentOffer}% OFF
                      </span>
                    </>
                  )}
                </p>
                <p className="mt-0 text-xs text-gray-500">{productsDetails.including_tax === "Yes" ? "(incl. of all taxes)" : "(excl. of all taxes)"}</p>
              </div>
            </div>

            {/* Add Button and Delivery Info */}
            <div className="flex flex-col items-end gap-2">
              <div className="relative">

                <button
                  className={` bg-gray-400 text-white px-12 py-3 rounded-lg shadow-md flex items-center gap-2 mb-8 ${sizes?.length > 0 && !selectedSize
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                    }`}
                  style={{ backgroundColor: sizes?.length > 0 && !selectedSize ? "" : themeColor }}
                  onMouseEnter={(e) => {
                    const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
                    e.currentTarget.style.backgroundColor = sizes?.length > 0 && !selectedSize ? "" : darkenedColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = sizes?.length > 0 && !selectedSize ? "" : themeColor;
                  }}
                  disabled={sizes?.length > 0 && !selectedSize}
                  onClick={async () => {
                    if (sizes?.length === 0 || selectedSize) {
                      try {
                        const payload = {
                          product_auto_id: productsDetails?.product_auto_id,
                          added_by_id: productsDetails?.user_auto_id,
                          cart_quantity:
                            productsDetails?.moq && productsDetails.moq !== ""
                              ? productsDetails.moq
                              : 1,
                          ...(sizes?.length !== 0 && {
                            size: selectedSizeId,
                            size_price: currentPrice,
                          }),
                          ...(isCustomizable &&
                            uploadedImage && { cust_image: uploadedImage }),
                        };

                        const res = await addToCart(payload);

                        // 🚫 ALREADY IN CART → stop here
                        if (res?.message && res.message.toLowerCase().includes("already")) {
                          setCartMessage({
                            text: "Product is already present in cart",
                            type: "error",
                          });
                          return; // ⛔ no navigation
                        }

                        // ✅ SUCCESS
                        if (res?.status === "1") {
                          setCartMessage({
                            text: res.message || "Added to cart",
                            type: "success",
                          });

                          setTimeout(() => {
                            navigate("/cart");
                          }, 1000);
                        } else {
                          setCartMessage({
                            text: res?.message || "Failed to add product to cart",
                            type: "error",
                          });
                        }

                      } catch (error) {
                        setCartMessage({ text: error.message || "Failed to add product to cart.", type: "error" });
                      }
                    } else {
                      setCartMessage({ text: "Select a Size", type: "error" });
                      return;
                    }
                  }}
                >
                  {sizes?.length > 0 && !selectedSize
                    ? "Select"
                    : `Add | ₹ ${sizes?.length > 0
                      ? currentPrice
                      : productsDetails?.final_product_price
                    }`}
                </button>

                {cartMessage.text && (
                  <div
                    className={`absolute left-0 right-0 top-[-2.7rem] text-center p-2 text-sm z-10 ${cartMessage.type === "error" ? "text-red-500" : "text-green-500"
                      }`}
                  >
                    {cartMessage.text}
                  </div>
                )}

              </div>


              <div className="flex justify-center space-x-4">
                {showViews && isProductViewsFactual && (
                  <p className="flex items-center text-sm font-medium text-black">
                    <IoEyeSharp className="mr-1" size={18} />
                    {viewCount} people are viewing this item. Don’t wait!
                  </p>
                )}
              </div>

              <div className="flex items-center gap-2 text-sm text-gray-600">
                <span className="material-icons">Expected delivery in </span>
                {productsDetails.time} {productsDetails.time_unit}
              </div>
            </div>
          </div>
        </div>
      </div>
      {faqs.length > 0 && (
        <section className="faq-section">
          <h2 className="faq-title">Frequently Asked Questions</h2>

          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3 className="faq-question">{faq.question}</h3>
              <p className="faq-answer">{faq.answer}</p>
            </div>
          ))}
        </section>
      )}

      {faqs.length > 0 && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faqs.map(faq => ({
                "@type": "Question",
                name: faq.question,
                acceptedAnswer: {
                  "@type": "Answer",
                  text: faq.answer,
                },
              })),
            }),
          }}
        />
      )}
    </>
  );
};

export default ProductDetail4;